<template>
  <v-flex>
    <!-- Botón para abrir diálogo (modo compacto) -->
    <v-btn v-if="dial" @click="dialog = true" outlined color="primary" class="mb-4">
      <v-icon left>mdi-plus</v-icon>
      Agregar item
    </v-btn>

    <!-- Contenedor principal (modo completo) -->
    <v-container v-if="!dial" fluid>
      <v-card outlined elevation="2">



        <!-- Filtros avanzados -->
        <v-expansion-panels flat>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-chip color="primary" outlined>
                <v-icon left small>mdi-counter</v-icon>
                {{ pagination.total }} artículos
              </v-chip>

              <v-spacer></v-spacer>

              <!-- Botón Nuevo Artículo -->
              <v-tooltip top v-if="showButonNewArticle && hasFeature('INV-03')">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="success" @click="newArticle()" class="mx-5" v-bind="attrs" v-on="on" outlined>
                    <v-icon left>mdi-plus</v-icon> NUEVO ARTÍCULO
                  </v-btn>
                </template>
                <span>Registrar nuevo artículo</span>
              </v-tooltip>

              <!-- Botón Exportar a Excel -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="teal darken-2" @click.stop="exportToExcel()" class="mr-5" v-bind="attrs" v-on="on"
                    outlined :loading="exporting" :disabled="exporting || loading">
                    <v-icon left>mdi-microsoft-excel</v-icon> EXCEL
                  </v-btn>
                </template>
                <span>Descargar en Excel los artículos según los filtros aplicados</span>
              </v-tooltip>


              Filtros avanzados
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" md="3">
                  <v-autocomplete v-model="filters.item_type" :items="itemTypes" item-value="id" item-text="name"
                    color="primary" label="Tipo de producto" outlined dense @change="resetPaginationAndFilter" clearable
                    prepend-inner-icon="mdi-shape" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete v-model="filters.unit" :items="units" item-value="id" item-text="name" color="primary"
                    label="Unidad de medida" outlined dense @change="resetPaginationAndFilter" clearable
                    prepend-inner-icon="mdi-ruler" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete v-model="filters.item_category" :items="categorys" item-value="id" item-text="name"
                    color="primary" label="Categoría" outlined dense @change="resetPaginationAndFilter" clearable
                    prepend-inner-icon="mdi-tag" />
                </v-col>
                <v-col cols="12" md="3">
                  <v-btn @click="clearAllFilters" outlined color="warning" block class="mt-2">
                    <v-icon left>mdi-filter-remove</v-icon>
                    Limpiar filtros
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-divider></v-divider>

        <!-- Barra de búsqueda y acciones -->
        <v-card-text class="pb-2">
          <v-row align="center">
            <v-col cols="12" md="8">
              <v-text-field v-model="search" @input="debounceSearch" append-icon="mdi-magnify"
                label="Buscar artículos..." outlined dense clearable
                hint="Buscar por nombre, unidad, tipo, categoría o ID" persistent-hint
                prepend-inner-icon="mdi-magnify" />
            </v-col>
            <v-col cols="12" md="4">
              <v-row>
                <v-col cols="6">
                  <v-select v-model="orderBy" :items="sortOptions" item-value="value" item-text="text"
                    label="Ordenar por" outlined dense @change="resetPaginationAndFilter" />
                </v-col>
                <v-col cols="6">
                  <v-btn-toggle v-model="orderDirection" mandatory @change="resetPaginationAndFilter">
                    <v-btn small value="ASC">
                      <v-icon>mdi-sort-ascending</v-icon>
                    </v-btn>
                    <v-btn small value="DESC">
                      <v-icon>mdi-sort-descending</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>


            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Tabla de datos -->
        <v-data-table :headers="headerArticle" :items="articles" :loading="loading" hide-default-footer locale="es-do"
          no-data-text="No hay artículos disponibles" loading-text="Cargando artículos..." class="elevation-0">
          <template v-slot:[`item.item_id`]="{ item }">
            <v-chip small color="primary" outlined>
              {{ item.item_id }}
            </v-chip>
          </template>

          <template v-slot:[`item.item_image`]="{ item }">
            <v-avatar size="40" class="ma-1">
              <v-img :src="item.item_image" :alt="item.item_name">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-icon color="grey lighten-2">mdi-image</v-icon>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>
          </template>

          <template v-slot:[`item.item_name`]="{ item }">
            <div>
              <div class="font-weight-medium">{{ item.item_name }}</div>
              <div class="caption text--secondary" v-if="item.item_note">
                {{ item.item_note }}
              </div>
            </div>
          </template>

          <template v-slot:[`item.active`]="{ item }">
            <v-chip :color="item.active ? 'success' : 'error'" :text-color="item.active ? 'white' : 'white'" small>
              {{ item.active ? 'Activo' : 'Inactivo' }}
            </v-chip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon small color="primary" @click="editArticle(item)">
                  <v-icon>{{ icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ name }}</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <!-- Paginación personalizada -->
        <v-divider></v-divider>
        <v-card-actions>
          <v-row align="center" class="ma-0">

            <v-col cols="12" md="12">
              <v-pagination v-model="currentPage" :length="pagination.totalPages" :total-visible="7" @input="changePage"
                color="primary" />
            </v-col>
          </v-row>
        </v-card-actions>

        <!-- Información de paginación -->
        <v-card-text class="text-center caption">
          Mostrando {{ startItem }} - {{ endItem }} de {{ pagination.total }} artículos
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Diálogo de selección -->
    <v-dialog v-model="dialog" width="95%" max-width="1200px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-package-variant</v-icon>
          Selección de artículos
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Contenido del diálogo simplificado -->
        <v-card-text class="pa-0">
          <!-- Filtros en diálogo -->
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field v-model="search" @input="debounceSearch" append-icon="mdi-magnify"
                  label="Buscar artículos..." outlined dense clearable />
              </v-col>
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="4">
                    <v-autocomplete v-model="filters.item_type" :items="itemTypes" item-value="id" item-text="name"
                      label="Tipo" outlined dense @change="resetPaginationAndFilter" clearable />
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete v-model="filters.unit" :items="units" item-value="id" item-text="name"
                      label="Unidad" outlined dense @change="resetPaginationAndFilter" clearable />
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete v-model="filters.item_category" :items="categorys" item-value="id" item-text="name"
                      label="Categoría" outlined dense @change="resetPaginationAndFilter" clearable />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>

          <!-- Tabla en diálogo -->
          <v-data-table :headers="headerArticleDialog" :items="articles" :loading="loading" hide-default-footer
            height="60vh" fixed-header locale="es-do" no-data-text="No hay artículos disponibles"
            loading-text="Cargando artículos...">
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn color="primary" small @click="editArticle(item)">
                <v-icon left small>{{ icon }}</v-icon>
                {{ name }}
              </v-btn>
            </template>
          </v-data-table>

          <!-- Paginación en diálogo -->
          <v-divider></v-divider>
          <v-container>
            <v-row align="center">
              <v-col cols="6">
                <v-select v-model="currentLimit" :items="limitOptions" label="Por página" outlined dense
                  @change="changeLimit" hide-details />
              </v-col>
              <v-col cols="6">
                <v-pagination v-model="currentPage" :length="pagination.totalPages" :total-visible="5"
                  @input="changePage" color="primary" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import ExcelJS from "exceljs";

export default {
  name: "ItemSelectionList",
  props: {
    items_catalogue: {
      type: Boolean,
      default: false,
    },
    catalogues_id: {
      type: Number,
      default: 0,
    },
    dial: {
      type: Boolean,
      default: true,
    },
    showButonNewArticle: {
      type: Boolean,
      default: false,
    },
    startFilter: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-pencil",
    },
    name: {
      type: String,
      default: "Editar",
    },
    typeView: {
      type: Boolean,
      default: true,
    },
    searchWithLike: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    loading: false,
    exporting: false,
    dialog: false,
    articles: [],
    itemTypes: [],
    categorys: [],
    units: [],

    // Filtros
    filters: {
      unit: null,
      item_type: null,
      item_category: null,
      account_category: null,
      tax_type: null,
      inventory_product: null,
      negative_sale: null,
    },

    // Búsqueda y ordenamiento
    search: "",
    orderBy: "item_name",
    orderDirection: "ASC",

    // Paginación
    currentPage: 1,
    currentLimit: 20,
    pagination: {
      page: 1,
      limit: 20,
      total: 0,
      totalPages: 0,
      hasNext: false,
      hasPrev: false
    },

    // Opciones
    limitOptions: [
      { text: "10 por página", value: 10 },
      { text: "20 por página", value: 20 },
      { text: "50 por página", value: 50 },
      { text: "100 por página", value: 100 }
    ],

    sortOptions: [
      { text: "Nombre", value: "item_name" },
      { text: "ID", value: "item_id" },
      { text: "Tipo", value: "item_type_name" },
      { text: "Categoría", value: "item_category_name" },
      { text: "Unidad", value: "unit_name" }
    ],

    // Debounce timer
    searchTimer: null,

    // Headers de tabla
    headerArticle: [
      {
        text: "ID",
        align: "start",
        value: "item_id",
        width: "80px"
      },
      {
        text: "Imagen",
        value: "item_image",
        sortable: false,
        width: "80px"
      },
      {
        text: "Descripción",
        value: "item_name",
        width: "300px"
      },
      {
        text: "Unidad",
        value: "unit_name",
        width: "150px"
      },
      {
        text: "Tipo",
        value: "item_type_name",
        width: "150px"
      },
      {
        text: "Categoría",
        value: "item_category_name",
        width: "150px"
      },
      {
        text: "Estado",
        value: "active",
        width: "100px"
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        width: "100px"
      },
    ],
  }),

  computed: {
    headerArticleDialog() {
      return this.headerArticle.filter(h => h.value !== 'item_image');
    },

    startItem() {
      return (this.currentPage - 1) * this.currentLimit + 1;
    },

    endItem() {
      const end = this.currentPage * this.currentLimit;
      return Math.min(end, this.pagination.total);
    }
  },

  watch: {
    catalogues_id: {
      handler: function (newValue) {
        if (newValue != 0) {
          this.getArticlesByCatalogue(newValue);
        }
      },
      immediate: true,
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.loadStaticData();

      if (this.items_catalogue === true) {
        if (this.catalogues_id != 0) {
          this.getArticlesByCatalogue(this.catalogues_id);
        }
      } else {
        this.getArticles();
      }
    },

    async loadStaticData() {
      try {
        // Cargar datos estáticos en paralelo
        const [unitsRes, itemTypesRes, categoriesRes] = await Promise.all([
          this.api_Get("inventory/units"),
          this.api_Get("inventory/itemTypes"),
          this.api_Get("inventory/categories")
        ]);

        this.units = await unitsRes.json();
        this.itemTypes = await itemTypesRes.json();
        this.categorys = await categoriesRes.json();
      } catch (error) {
        console.error("Error loading static data:", error);
      }
    },

    async getArticles() {
      this.loading = true;

      try {
        const requestData = {
          filters: this.buildFiltersString(),
          page: this.currentPage,
          limit: this.currentLimit,
          search: this.search,
          orderBy: this.orderBy,
          orderDirection: this.orderDirection
        };

        const response = await this.api_Post("inventory/articles", requestData);
        const result = await response.json();

        // Procesar imágenes
        result.data.forEach((element) => {
          if (element.image_json == null) {
            element.item_image = "image-not-available.jpg";
          } else {
            element.item_image = this.get_storage(element.image_json);
          }
        });

        this.articles = result.data;
        this.pagination = result.pagination;

      } catch (error) {
        console.error("Error loading articles:", error);
        this.$toast.error("Error al cargar los artículos");
      } finally {
        this.loading = false;
      }
    },

    buildFiltersString() {
      const conditions = [];

      if (this.filters.unit) {
        conditions.push(`UNIT_ID=${this.filters.unit}`);
      }
      if (this.filters.item_type) {
        conditions.push(`ITEM_TYPE_ID=${this.filters.item_type}`);
      }
      if (this.filters.item_category) {
        conditions.push(`ITEM_CATEGORY_ID=${this.filters.item_category}`);
      }
      if (this.filters.account_category) {
        conditions.push(`ACCOUNT_CATEGORY_ID=${this.filters.account_category}`);
      }
      if (this.filters.tax_type) {
        conditions.push(`TAX_TYPE_ID=${this.filters.tax_type}`);
      }
      if (this.filters.inventory_product && this.filters.inventory_product != 1) {
        conditions.push(`INVENTORY_PRODUCT=${this.getType(this.filters.inventory_product)}`);
      }
      if (this.filters.negative_sale && this.filters.negative_sale != 1) {
        conditions.push(`NEGATIVE_SALE=${this.getType(this.filters.negative_sale)}`);
      }

      return conditions.length ? conditions.join(" AND ") : "";
    },

    // Métodos de paginación
    changePage(page) {
      this.currentPage = page;
      this.getArticles();
    },

    changeLimit(newLimit) {
      this.currentLimit = newLimit;
      this.currentPage = 1;
      this.getArticles();
    },

    resetPaginationAndFilter() {
      this.currentPage = 1;
      this.getArticles();
    },

    // Búsqueda con debounce
    debounceSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getArticles();
      }, 500);
    },

    // Limpiar filtros
    clearAllFilters() {
      this.filters = {
        unit: null,
        item_type: null,
        item_category: null,
        account_category: null,
        tax_type: null,
        inventory_product: null,
        negative_sale: null,
      };
      this.search = "";
      this.resetPaginationAndFilter();
    },

    // Métodos existentes
    async getArticlesByCatalogue(id) {
      // Implementar según sea necesario
      let resultCatalogues = await this.api_Get(`inventory/catalogues/details/${id}`);
    },

    getType(id) {
      if (id == 2) return true;
      else if (id == 3) return false;
    },

    // Descarga en Excel todos los artículos que cumplen los filtros/búsqueda actuales
    async exportToExcel() {
      this.exporting = true;

      try {
        const response = await this.api_Post("inventory/articles_export", {
          filters: this.buildFiltersString(),
          search: this.search,
          orderBy: this.orderBy,
          orderDirection: this.orderDirection,
        });

        if (!response.ok) {
          this.$toast.error("Error al generar el reporte de artículos");
          return;
        }

        const rows = await response.json();

        if (!rows.length) {
          this.$toast.info("No hay artículos para exportar con los filtros actuales");
          return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Artículos");

        worksheet.columns = [
          { header: "ID", key: "item_id", width: 10 },
          { header: "Descripción", key: "item_name", width: 55 },
          { header: "Referencia / Nota", key: "item_note", width: 40 },
          { header: "Unidad", key: "unit_name", width: 18 },
          { header: "Tipo", key: "item_type_name", width: 18 },
          { header: "Categoría", key: "item_category_name", width: 22 },
          { header: "Artículo padre", key: "parent_name", width: 30 },
          { header: "Venta negativa", key: "negative_sale", width: 16 },
          { header: "Interno", key: "is_internal", width: 12 },
          { header: "Creado por", key: "created_by_name", width: 25 },
          { header: "Estado", key: "active", width: 12 },
        ];

        rows.forEach((item) => {
          worksheet.addRow({
            item_id: item.item_id,
            item_name: item.item_name,
            item_note: item.item_note,
            unit_name: item.unit_name,
            item_type_name: item.item_type_name,
            item_category_name: item.item_category_name,
            parent_name: item.parent_name,
            negative_sale: item.negative_sale ? "Sí" : "No",
            is_internal: item.is_internal ? "Sí" : "No",
            created_by_name: item.created_by_name,
            active: item.active ? "Activo" : "Inactivo",
          });
        });

        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
        });

        worksheet.views = [{ state: "frozen", ySplit: 1 }];
        worksheet.autoFilter = {
          from: { row: 1, column: 1 },
          to: { row: 1, column: worksheet.columns.length },
        };

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Articulos ${new Date().toLocaleDateString("es-DO").replace(/\//g, "-")}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);

        this.$toast.success(`${rows.length} artículos exportados`);
      } catch (error) {
        console.error("Error exporting articles:", error);
        this.$toast.error("Error al generar el reporte de artículos");
      } finally {
        this.exporting = false;
      }
    },

    newArticle() {
      this.$emit("newArticle", true);
    },

    editArticle(item) {
      this.$nextTick(() => {
        this.$emit("getItemToEdit", item);
        if (this.dial) {
          this.dialog = false;
        }
      });
    },
  },
};
</script>

<style scoped>
/* Data Table Enhancements */
.v-data-table>>>.v-data-table__wrapper {
  border-radius: 8px;
}

.v-data-table>>>thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 11px !important;
  letter-spacing: 0.5px;
  color: #475569 !important;
  border-bottom: 2px solid #e2e8f0 !important;
}

.v-data-table>>>tbody tr {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-data-table>>>tbody tr:hover {
  background: linear-gradient(90deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.02) 100%) !important;
  transform: translateX(2px);
  box-shadow: -3px 0 0 0 var(--v-primary-base);
}

.v-data-table>>>tbody td {
  border-bottom: 1px solid #f1f5f9 !important;
}

/* Expansion Panel Styling */
.v-expansion-panel {
  border-radius: 12px !important;
  overflow: hidden;
}

.v-expansion-panel-header {
  min-height: 64px !important;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  font-weight: 600;
  transition: all 0.3s ease;
}

.v-expansion-panel-header:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.v-expansion-panel-content>>>.v-expansion-panel-content__wrap {
  padding: 24px;
  background: #fafbfc;
}

/* Chip Enhancements */
.v-chip {
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.v-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.v-chip.v-chip--outlined {
  border-width: 2px;
}

/* Avatar Styling */
.v-avatar {
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}

.v-avatar:hover {
  border-color: var(--v-primary-base);
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
}

/* Button Enhancements */
.v-btn {
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  font-weight: 600 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.v-btn:not(.v-btn--text):not(.v-btn--outlined) {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.v-btn:hover:not(.v-btn--text) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.v-btn.v-btn--outlined {
  border-width: 2px !important;
}

.v-btn.v-btn--icon {
  background: rgba(var(--v-primary-base), 0.05);
  transition: all 0.2s ease;
}

.v-btn.v-btn--icon:hover {
  background: var(--v-primary-base);
  color: white !important;
}

/* Text Field Enhancements */
.v-text-field.v-text-field--outlined>>>fieldset {
  border-radius: 10px;
  border-width: 2px;
  border-color: #e2e8f0;
  transition: all 0.3s ease;
}

.v-text-field.v-text-field--outlined.v-input--is-focused>>>fieldset {
  border-color: var(--v-primary-base);
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

/* Autocomplete & Select Enhancements */
.v-autocomplete.v-text-field--outlined>>>fieldset,
.v-select.v-text-field--outlined>>>fieldset {
  border-radius: 10px;
  border-width: 2px;
  border-color: #e2e8f0;
}

.v-autocomplete.v-input--is-focused>>>fieldset,
.v-select.v-input--is-focused>>>fieldset {
  border-color: var(--v-primary-base);
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

/* Pagination Enhancements */
.v-pagination>>>.v-pagination__item,
.v-pagination>>>.v-pagination__navigation {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  border-radius: 8px !important;
  font-weight: 600;
  transition: all 0.2s ease;
  min-width: 36px;
  height: 36px;
}

.v-pagination>>>.v-pagination__item:hover,
.v-pagination>>>.v-pagination__navigation:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
}

.v-pagination>>>.v-pagination__item--active {
  background: linear-gradient(135deg, var(--v-primary-base) 0%, var(--v-primary-darken1) 100%) !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
}

/* Card Enhancements */
.v-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
}

.v-card.v-card--outlined {
  border: 2px solid #e2e8f0;
}

/* Dialog Enhancements */
.v-dialog>.v-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.v-dialog .v-card__title {
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
  padding: 20px 24px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

/* Divider Styling */
.v-divider {
  border-color: #e2e8f0 !important;
  border-width: 1px !important;
}

/* Tooltip Enhancements */
.v-tooltip__content {
  background: #1e293b !important;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Button Toggle Enhancements */
.v-btn-toggle>>>.v-btn {
  border-radius: 8px !important;
  margin: 0 2px;
}

.v-btn-toggle>>>.v-btn--active {
  background: var(--v-primary-base) !important;
  color: white !important;
}

/* Loading State */
.v-data-table>>>.v-data-table__progress {
  height: 3px;
}

.v-data-table>>>.v-data-table__progress .v-progress-linear {
  background: linear-gradient(90deg, var(--v-primary-base), var(--v-primary-lighten2));
}

/* Caption Text */
.caption {
  color: #64748b;
  font-weight: 500;
  letter-spacing: 0.2px;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
  transition: background 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Animation Classes */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-card,
.v-data-table {
  animation: fadeInUp 0.4s ease-out;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .v-expansion-panel-header {
    min-height: 56px !important;
  }

  .v-expansion-panel-content>>>.v-expansion-panel-content__wrap {
    padding: 16px;
  }
}
</style>